<!-- eslint-disable vue/multi-word-component-names -->
<template>
    <div class="footer" v-show="isShow">
        <div class="baseWidth">

            <div class="footer-content">
                <div class="footerFram__list">
                    <div class="footerFram__listPic">
                    </div>
                </div>
                <div class="footerFram__list">
                    <div class="footerFram__listTitle">{{ $t('footer.address') }}</div>

                    <div class="footerFram__listAdd" style="height: 30px;line-height: 30px;">
                        <a href="/us/list">{{ $t('footer.addressDetail') }}</a>
                    </div>

                    <div class="footerFram__listTel" style="height: 30px;line-height: 30px;">
                        <a href="/us/list">400 0960 592</a>
                    </div>

                </div>
                <div class="footerFram__list">
                    <div class="footerFram__listTitle">{{ $t('footer.publicAccount') }}</div>
                    <div class="footerFram__listCode"></div>
                </div>

            </div>
            <div class="copyright">
                <!-- <span>科建版权所有</span> -->
            </div>
        </div>
        <div class="footerCopyright">
            <span class="company-txt" @click="goPreview('BusinessLicense')">@2017-{{ currentYear }}
                广东快车科技股份有限公司版权所有</span>
            <a class="miit-txt" style="margin: 0 3vh;" @click="goNewPage">{{ currentValue }}</a>
            <span class="certificate-txt" @click="goPreview('certificate')">网络文化经营许可证： 粤网文｛2023｝ 2285-163号</span>
            <span class="certificate-txt" style="margin: 0 3vh;"
                @click="goPreview('telecommunications')">增值电信业务经营许可证</span>
        </div>
    </div>

</template>

<script>
export default {
    data() {
        return {
            router: true,
            defaultActive: "/",
            isShow: true,
            currentYear: '',
            currentValue: '',
        };
    },
    // eslint-disable-next-line vue/multi-word-component-names
    name: "myfooter",
    created() {
        const currentYear = new Date().getFullYear();
        this.currentYear = currentYear;
    },
    mounted() {
        const url = window.location.href;
        this.currentValue = this.matchIcpNumber(url);
    },
    methods: {
        goNewPage() {
            window.open("https://beian.miit.gov.cn/", '_blank')
        },
        goPreview(type) {
            window.open(`/imgPreview?image=${encodeURIComponent(type)}`, '_blank');
        },
        matchIcpNumber(url) {
            if (url.includes('itos.cn') || url.includes('www.itos.cn')) {
                return '粤ICP备11046395号-1';
            } else if (url.includes('itkc.cn') || url.includes('www.itkc.cn')) {
                return '粤ICP备11046395号-2';
            } else {
                return '未找到匹配的备案号';
            }
        },
    },
}
</script>

<style lang="scss" scoped>
.footer {
    width: 100%;
    padding: 0 !important;
    // overflow: hidden;
    background-color: #111111;
    height: 480px;

    .baseWidth {
        width: 100%;
        max-width: 1150px;
        margin: 0 auto;
        box-sizing: border-box;
    }

    .footer-content {
        height: 300px;
        display: flex;
        padding-top: 52px;
        box-sizing: border-box;

        .footerFram__list {

            flex: 1;
            flex: 1;
            margin-left: 50px;
            text-align: left;

            .footerFram__listTitle {
                height: 40px;
                color: white;
                font-size: 14px;
                border-bottom: 1px solid #282828;
            }

            .footerFram__listAdd {
                margin-top: 15px;
                background-image: url(../assets/icon/add.jpg);
                background-size: auto;
                background-repeat: no-repeat;

                background-position: left center;
                padding-left: 39px;
                box-sizing: border-box;
                color: #7e7e7e;
                font-size: 14px;
            }

            .footerFram__listTel {
                margin-top: 25px;
                background-image: url(../assets/icon/tel.jpg);
                background-size: auto;
                background-position: left center;
                padding-left: 39px;
                box-sizing: border-box;
                color: #7e7e7e;
                font-size: 14px;
            }

            .footerFram__listText {
                margin-top: 15px;
                color: #7e7e7e;
                font-size: 14px;

                .listText__list {
                    margin-top: 15px;
                    color: #7e7e7e;
                }

            }
        }

        .footerFram__list:first-child {
            margin-left: 0;
        }

        .footerFram__listPic {
            height: 64px;
            background-image: url(../assets/img/logo.png);
            background-size: 75% auto;
            background-repeat: no-repeat;
            background-position: left center;
        }

    }



    .footerLink {
        margin-top: 75px;
        border-top: 1px solid #282828;
        padding-top: 20px;
        color: #7e7e7e;
        font-size: 14px;

        p {
            display: flex;
            justify-content: center;
        }

        p span {
            color: #7e7e7e;
            font-size: 14px;
            text-decoration: none;
            margin: 0 10px;
        }
    }

    .footerFram__listCode {
        margin-top: 15px;
        height: 128px;
        width: 128px;
        background-image: url(../assets/icon/code.jpg);
        background-size: 100% 100%;
        background-position: left top;
    }

    .footerCopyright {
        margin-top: 40px;
        text-align: center;
        color: #7e7e7e;
        font-size: 14px;
    }

    .miit-txt:hover,
    .company-txt:hover,
    .certificate-txt:hover {
        color: #db4242;
        cursor: pointer;
    }

    .copyright {
        height: 30px;
        // background: #125688;

        span {
            color: #fff;
            line-height: 30px;
        }
    }

    a:hover {
        color: #0075bb;
        text-decoration: underline solid #0075bb;
    }
}

@media screen and (max-width: 1200px) {
    .footer{
        width: 100%;
        height: 500px;
        .footer-content {
            height: auto;
            flex-direction: column;
            padding-top: 30px;
            .footerFram__listPic {
                width: 166px;
                height: 29px;
                background-size: 100% 100%;
            }
            .footerFram__list {
                width: calc(100% - 70px);
                max-width: 300px;
                height: 64px;
                .footerFram__listTitle {
                    height: 27px;
                    margin-top: 2vh;
                }
                
                .footerFram__listAdd {
                    height: 24px!important;
                    line-height: 24px!important;
                    width: 100%;
                    margin-top: 12px;
                }
                .footerFram__listTel {
                    margin-top: 30px;
                }
            }
            
            .footerFram__list:first-child {
                margin-left: 50px;
            }
        }
        .footerCopyright {
            margin-top: 0;
            display: flex;
            flex-direction: column;
            line-height: 24px;
        }
        .footerFram__listCode {
            height: 68px;
            width: 68px;

        }
    }
}
</style>